import { driversSlice } from '../store/slice';
import { driverUploadSlice, myDriverUploadSlice } from '../store/upload-slice';

export const {
  setDriver,
  setMyDriver,
  updateMyDriver,
  updateDriver,
  resetDriver,
  setAllDrivers,
  setReferralCode,
  setDriverWorkload,
  setDrivers,
} = driversSlice.actions;

export const { setDocDefinitions, updateUploadFormValue } = driverUploadSlice.actions;
export const {
  setDocDefinitions: setMyDriverDocDefinitions,
  updateUploadFormValue: updateMyDriverUploadFormValue,
} = myDriverUploadSlice.actions;
